// JavaScript Document
// eslint-disable-next-line no-unused-vars
export default class Person {
  netId = 'unk';
  fullName = 'None';
  email;
  telephone;
  upi;
  yaleStatus = '';
  yaleRelationship;
  yaleAffiliation;

  constructor(obj) {
    if (typeof obj === 'undefined' || obj == null) return;

    if (typeof obj.netId !== 'undefined') this.netId = obj.netId.toLowerCase();
    if (typeof obj.fullName !== 'undefined') this.fullName = obj.fullName;
    if (typeof obj.email !== 'undefined') this.email = obj.email;
    if (
      typeof obj.telephone !== 'undefined'
      && obj.telephone != null
      && obj.telephone.trim() != ''
    ) this.telephone = obj.telephone;
    if (typeof obj.upi !== 'undefined') this.upi = obj.upi;
    if (typeof obj.supervisor !== 'undefined') this.supervisor = obj.supervisor;
    if (typeof obj.yaleStatus !== 'undefined') this.yaleStatus = obj.yaleStatus;
    if (typeof obj.yaleRelationship !== 'undefined') this.yaleRelationship = obj.yaleRelationship;
    if (typeof obj.yaleAffiliation !== 'undefined') this.yaleAffiliation = obj.yaleAffiliation;

    if (typeof obj.person !== 'undefined') {
      this.netId = obj.person.netId;
      this.upi = obj.person.upi;
      this.fullName = obj.person.fullName;
    }
  }
}

export { Person };
